import React, { useState } from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import { useNavigate } from 'react-router-dom';
import { ACTIONS, KEYS, URLS } from '../../_config';
import { useDispatch } from 'react-redux';
import Icon from '../../components/icons';
import { DateRangePicker } from 'rsuite';
import "rsuite/dist/rsuite.css";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import moment from 'moment';
import CurrentRating from './currentRating';
import Filter from '../../components/filter';
import OverallRating from './overallRating';
import Header from '../../components/header';

const Ratings: React.FC = () => {
    const [filterValue, setFilterValue] = useState<any>({})

    const navigate = useNavigate();
    const dispatch = useDispatch();


    const handleApplyFilter = (filterData: any) => {
        // console.log("Applied filters:", filterData);
        setFilterValue(filterData);
    };

    const handleClearFilter = () => {
        setFilterValue(null);
    };


    return (
        <div className="flex">
            <SideMenuBar sideMenuBarClass={'w-64 h-screen bg-white '} />

            <div className="w-full bg-sky-50 overflow-y-auto" style={{ maxHeight: '100vh' }}>
                <Header />
                <div className="p-8">
                    <h1 className="text-xl font-semibold text-gray-600 mb-2">Ratings</h1>

                    {/* Paragraph */}
                    <p className="text-sm text-gray-600 mb-6">
                        Comprehensive ratings overview paired with sentiment correlations for deeper context.
                    </p>
                    <div className="flex justify-between mb-5 ipad-column">
                        <div className="flex-1 ipad-order-2">
                            <div className="bg-white shadow-lg rounded-2xl p-6 mb-5">
                                <CurrentRating filterValue={filterValue} />
                            </div>

                            {/* Review List Section (below Review Summary) */}
                            <div className="bg-white shadow-lg rounded-2xl p-6">
                                <OverallRating filterValue={filterValue} />
                            </div>

                        </div>

                        {/* Right Column: Filter Accordion */}
                        <Filter
                            onApplyFilter={handleApplyFilter}
                            onClearFilter={handleClearFilter}
                            filterClass={'w-80 bg-white shadow-lg rounded-2xl p-6 ml-4 top-20 sticky h-[450px] ipad-static ipad-order-1 ipad-width-100 ipad-mb-2 '}
                        />
                    </div>

                </div>
            </div>

        </div>
    );
}
export default Ratings;